module.exports = __webpack_public_path__ + "static/media/icon22.c9b7498d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon22.svg
// module id = 499
// module chunks = 0